import { SYSAction } from "../../../../../../../../_ovlclient/src"
import {
  HookFieldGetList_ReturnType,
  HookFieldGetList_Type,
  HookFieldGetValueRender_ReturnType,
  HookFieldGetValueRender_Type,
  HookFormAutoInit_Type,
  HookFormChanged_Type,
  HookFormInit_ReturnType,
  HookFormInit_Type,
  HookFormValidate_Type,
  HookLookupsRefresh_ReturnType,
  HookTableBeforeSave_Type,
} from "../../../../../../../../_ovlclient/src/global/hooks"
import {
  FieldForceSave,
  FieldInitMandatory,
  FieldSetState,
  FieldSetVal,
  FieldVal,
} from "../../../../../../../../_ovlclient/src/library/forms/fieldapi"
import {
  FormGet,
  SYSFormState,
} from "../../../../../../../../_ovlclient/src/library/forms/formapi"
import { ScreenCurrent } from "../../../../../../../../_ovlclient/src/library/screenapi"
import { TableInit } from "../../../../../../../../_ovlclient/src/library/table/tableapi"
import { SYSEditorAssetDefaultFields } from "../../../../../../../../_ovlclient/ovlsyscomponents/syseditors/sysassetconfig01/formdef"
import {
  SYSEditorAssetDeserializeToFormFields,
  SYSEditorAssetFileGetNameAndExtension,
} from "../../../../../../../../_ovlclient/ovlsyscomponents/syseditors/sysassetconfig01/helpers"
import { SelectOfferFile } from "../../../../screens/qutoffering/offering/helpers"
import { hooks as offeringSettingssHookActions } from "../../offeringsettings/hookactions"
import { EditorDefaultHooks_SYSEditorAsset } from "../../../../../../../../_ovlclient/ovlsyscomponents/syseditors/sysassetconfig01/defaulthookactions"
import { SubFeatureHooksFromDefaultHooks } from "../../../../../../../../_ovlclient/src/moduleHelpers"
let HookField_U_PrtOfferingCadAttr_GetList =
  offeringSettingssHookActions.HookField_U_PrtOfferingCadAttr_GetList

let settingsValidate = offeringSettingssHookActions.HookFormValidate

const HookLookupsRefresh: SYSAction<HookLookupsRefresh_ReturnType> = (
  _,
  { global }
) => {
  let state = global.getState()
  return {
    CntctCode: state.app.global.QUT.lookups.CntctCode,
  }
}

const HookField_CntctCode_GetList: SYSAction<
  HookFieldGetList_Type,
  HookFieldGetList_ReturnType
> = (value, { global }) => {
  let state = global.getState()
  let dataState = state.app.global.QUT.lookups.CntctCode.data

  let data = Object.keys(dataState).reduce((val, k) => {
    if (
      dataState[k].CardCode === FieldVal(value.formState.fields["CardCode"])
    ) {
      val[k] = dataState[k]
    }
    return val
  }, {})
  return {
    data,
    lookupDef: state.app.global.QUT.lookups.CntctCode.lookupDef,
  }
}

const HookFormInit: SYSAction<
  HookFormInit_Type,
  Promise<HookFormInit_ReturnType>
> = async (value, { global }) => {
  let state = global.getState()
  if (value.formState.formType === "SYSTableRowEdit") {
    await FieldSetVal(value.formState.fields["File"], null)
    await FieldForceSave(value.formState.fields["File"])
    await FieldSetVal(
      value.formState.fields["CardCode"],
      FormGet("QUTBPFilter").fields["CardCode"].convertedValue
    )
    return { fieldsToRemove: [value.formState.fields["CardCode"].fieldKey] }
  }
}

const HookField_OfferType_GetList: SYSAction<
  HookFieldGetList_Type,
  HookFieldGetList_ReturnType
> = (value, { global }) => {
  let state = global.getState()
  return {
    data: {
      Target: { OfferType: "Target", OfferTypeName: "Soll Offerte" },
      Actual: { OfferType: "Actual", OfferTypeName: "Ist Offerte" },
    },
  }
}

const HookField_FileType_GetList: SYSAction<HookFieldGetList_Type> = (
  value,
  { global }
) => {
  let state = global.getState()
  let data = { bvx: { FileType: "bvx" } }
  data["3d"] = { FileType: "3d" }
  return { data }
}

const HookFormValidate: SYSAction<HookFormValidate_Type> = async (
  value,
  context
) => {
  if (value.formState.formType === "SYSTableRowEdit") {
    if (value.fieldKey === "File") {
      value.validatorUse("Mandatory")
    }
    settingsValidate(value, context)
  }
}

const HookField_File_GetValueRender: SYSAction<
  HookFieldGetValueRender_Type,
  HookFieldGetValueRender_ReturnType
> = (value, { global }) => {
  let state = global.getState()
  let actions = global.getActions()
  let file = value.row["File"]
  if (!file) {
    return
  }
  let fileO = JSON.parse(file)
  return { res: fileO.desc }
}

const HookTableBeforeSave: SYSAction<HookTableBeforeSave_Type> = async (
  value,
  { global }
) => {
  let state = global.getState()
  let actions = global.getActions()
  let offerType = FieldVal(value.formState.fields["OfferType"])
  let file = FieldVal(value.formState.fields["File"])
  let fileO = JSON.parse(file)
  let desc = fileO.desc
  await SelectOfferFile(
    value.resFiles[0].files[0],
    undefined,
    FieldVal(value.formState.fields["PrtOfferingCadUserField"]),
    FieldVal(value.formState.fields["U_PrtOfferingCadAttr"]),
    FieldVal(value.formState.fields["U_PrtOfferingCadVal"]),
    offerType,
    FieldVal(value.formState.fields["CardCode"]),
    FieldVal(value.formState.fields["CntctCode"]),
    desc
  )

  if (ScreenCurrent() === "QUTOfferingDetails") {
    //ScreenNavigateBack()
    let offeringToolState = state.app.features.QUTOffering
    offeringToolState.imageLoaded = ""
    offeringToolState.detailsMaterialChanged = true
    offeringToolState.detailsTransportChanged = true
    offeringToolState.detailsCostChanged = true

    TableInit("QUTOfferingMaterial", { resetStrategy: { ClearData: true } })
    TableInit("QUTOfferingCosts", { resetStrategy: { ClearData: true } })
    TableInit("QUTOfferingTransport", { resetStrategy: { ClearData: true } })
  }

  state.app.screens.QUTOffering.activeTab = offerType.toString().toLowerCase()
}

const HookFormChanged: SYSAction<HookFormChanged_Type> = async (
  value,
  { global }
) => {
  let state = global.getState()
  let actions = global.getActions()
  if (value.formState.formType === "SYSTableRowEdit") {
    let changedField = value.changedField
    if (
      changedField.fieldKey === "CardCode" &&
      changedField.validValueChanged
    ) {
      await FieldSetVal(value.formState.fields["CntctCode"], null)
    }
    if (
      changedField.fieldKey === "CntctCode" &&
      (!changedField.newValue || changedField.isValid)
    ) {
      let cadAttrVal = null
      let cadUserField = null
      let cadVal = null

      if (changedField.isValid) {
        let cadAttr = FieldVal(changedField.field, {
          lookupColumnKey: "U_PrtOfferingCadAttr",
        })

        if (!Number.isNaN(parseInt(cadAttr))) {
          cadUserField = cadAttr
          cadAttrVal = "Benutzerdefiniert"
        } else {
          cadAttrVal = cadAttr
        }

        cadVal = FieldVal(changedField.field, {
          lookupColumnKey: "U_PrtOfferingCadVal",
        })
      }
      await FieldSetState(value.fields["FileType"], !!changedField.newValue, {
        mode: "visible/readonly",
      })
      await FieldSetState(value.fields["File"], !!changedField.newValue)

      await FieldSetVal(value.fields["U_PrtOfferingCadAttr"], cadAttrVal, {
        watched: false,
        setFocus: changedField.isValid,
      })
      await FieldSetVal(value.fields["PrtOfferingCadUserField"], cadUserField)
      await FieldSetVal(value.fields["U_PrtOfferingCadVal"], cadVal)
    }
    if (
      changedField.fieldKey === "FileType" ||
      changedField.fieldKey === "U_PrtOfferingCadAttr"
    ) {
      let fileTypeValue = FieldVal(value.fields["FileType"])
      let is3d = fileTypeValue === "3d"

      await FieldSetState(value.fields["U_PrtOfferingCadAttr"], is3d)
      await FieldSetState(
        value.fields["PrtOfferingCadUserField"],
        is3d &&
          FieldVal(value.fields["U_PrtOfferingCadAttr"]) === "Benutzerdefiniert"
      )
      await FieldSetState(value.fields["U_PrtOfferingCadVal"], is3d)
    }
  }
}

const HookFormSYSEditorAssetInit: SYSAction<HookFormInit_Type> = async (
  value,
  { global, execution }
) => {
  FieldSetState(value.fields["Desc_00"], true)
  let res: HookFormInit_ReturnType = { fieldsToRemove: [] }
  res.fieldsToRemove.push("Val_00")
  res.fieldsToRemove.push("Ext_00")
  // get the valid extensions from baseform
  let parentFormState =
    global.getState().ovl.forms[value.formState.parent.formType][
      value.formState.parent.formId
    ]
  let parentFileType = FieldVal(parentFormState.fields["FileType"])
  FieldSetVal(value.fields["ValidExtensions"], `.${parentFileType}`)
  return res
}

export let hooks = {
  ...SubFeatureHooksFromDefaultHooks(
    EditorDefaultHooks_SYSEditorAsset,
    "HookForm",
    "SYSEditorAsset"
  ),
  HookLookupsRefresh,
  HookField_CntctCode_GetList,
  HookFormInit,
  HookFormSYSEditorAssetInit,
  HookField_OfferType_GetList,
  HookField_FileType_GetList,
  HookFormValidate,
  HookField_File_GetValueRender,
  HookTableBeforeSave,
  HookFormChanged,
  HookField_U_PrtOfferingCadAttr_GetList,
}
